/**
 * State used in rendering BreadcrumbDivider
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
